import { Fragment, useRef, useState, useEffect } from 'react'
import { fetchData, PostData } from '../Services/httpHandelars'
import { Dialog, Transition } from '@headlessui/react'
import { useGlobalContext } from '../context'
import Snackbar from '../Components/Snackbar';

export default function UserRegistration(props) {
  const { open, setOpen, ID, users, setID, setUsers } = props;
  const cancelButtonRef = useRef(null)

  const [form, setForm] = useState({
    _id:"",
    firstName: "", lastName: "", emailAddress: "", loginId: "", contact: "", role: "",
    residentialAddress: "", password: "", confirmPassword: "",
  })

  const [disable, setDisable] = useState(false);
  const [snacBar, setSnacBar] = useState({ snacStatus: false, message: "", snackType: "" });

  const { newUser, setNewUser } = useGlobalContext();

  useEffect(()=>{
    if(ID){
      const editUsers = users.find(user => user._id === ID)
      setForm({...form, 
        firstName: editUsers?.FirstName,
        lastName: editUsers?.LastName,
        emailAddress: editUsers?.EmailID,
        loginId: editUsers?.LoginID,
        contact: editUsers?.ContactNumber,
        residentialAddress: editUsers?.ResidentialAddress,
        role: editUsers?.Role,
        _id:ID

      })
    }
  },[ID])

  useEffect(
    () => {
      if (snacBar.snacStatus === true) {
        setTimeout(() => setSnacBar(false), 3000);
      }
    },

    [snacBar.snacStatus]
  );

  const handleDisable = () => {
    setDisable(!disable);
  }

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value })
    console.log(form);
  }

  const handleClose = () => {
    setOpen(false)
    setForm({})
    setID("")
  }

  const validatePassword = (pass) => {
    const reg = /(?=^.{8,16}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s)[0-9a-zA-Z!*^?](?=.*[+-_@#$%&])/
    return reg.test(pass)
  }

  const handleSubmit = (e) => {

    e.preventDefault();

    if(ID){
      // Edit User Func Starts *******************
      if (!form.firstName || !form.lastName || !form.emailAddress || !form.contact || !form.residentialAddress) {
        setSnacBar({
          ...snacBar,
          snacStatus: true,
          message: "Kindly fill all the fields",
          snackType: "Error"
        })
        return;
      }

      const update = {
        firstName: form.firstName,
        lastName: form.lastName,
        emailID: form.emailAddress,
        contactNumber: form.contact,
        residentialAddress: form.residentialAddress,
        role: form.role || "Admin",
        _id: ID
      }

      PostData("/api/user/updateUser", update).then((success) => {
        if (success.status === true) {
          console.log(success,"-------success")
          console.log("9 ----> ",users);
          const updatedUser = {
            FirstName: form.firstName,
            LastName: form.lastName,
            EmailID: form.emailAddress,
            ContactNumber: form.contact,
            LoginID :form.loginId,
            ResidentialAddress: form.residentialAddress,
            Role: form.role || "Admin",
            _id: ID
          }
          let updatedList = users.filter(u => u._id !== ID)
          updatedList.push(updatedUser)
          setUsers(updatedList)
          setOpen(false)
          setID("")
          setForm({})
          setSnacBar({
            ...snacBar,
            snacStatus: success.status,
            message: "User Updated Successfully",
            snackType: "Success"
          })
          // let data = {
          //   skip : 0,
          //   limit :10
          // };
          // PostData("/api/user/getUserData", data).then((data) => {
          //   let usersData = data.results.UserData;
          //   setUsers(usersData)
            
          //   setSnacBar({
          //     ...snacBar,
          //     snacStatus: data.status,
          //     message: "User Updated Successfully",
          //     snackType: "Success"
          //   })
          //   setOpen(false)
          //   setID("")
          //   setForm({})
          // }).catch(e => console.log(e))

        } else {
          setSnacBar({
            ...snacBar,
            snacStatus: success.status,
            message: "Responce Failed",
            snackType: "Error"
          })
        }
    
      }, (err) => {
        console.log(err);
      });
      // I will do Edit User Func Endd ****************
    }
    else{
      // New User Creation********************************************
      if (!form.firstName || !form.lastName || !form.emailAddress || !form.loginId || !form.contact || !form.residentialAddress) {
        setSnacBar({
          ...snacBar,
          snacStatus: true,
          message: "Kindly fill all the fields",
          snackType: "Error"
        })
        return;
      }
      const data = {
        FirstName: form.firstName,
        LastName: form.lastName,
        EmailID: form.emailAddress,
        LoginID: form.loginId,
        ContactNumber: form.contact,
        ResidentialAddress: form.residentialAddress,
        Role: form.role || "Admin",
      }
      if (!disable) {
        if (!form.password || !form.confirmPassword) {
          setSnacBar({ 
            ...snacBar,
            snacStatus: true,
            message: "Kindly fill all the fields",
            snackType: "Error"
          })
          return;
        }
        else{
          if (validatePassword(form.password) && validatePassword(form.confirmPassword)) {
            if (form.password === form.confirmPassword) {
              data["password"] = form.password;
              data["ConfirmPassword"] = form.confirmPassword;
              data["autoGenerated"] = disable;
            }
            else {
              setSnacBar({
                ...snacBar,
                snacStatus: true,
                message: "Password does not match!",
                snackType: "Error"
              })
              return;
            }
          }
          else {
            setSnacBar({
              ...snacBar,
              snacStatus: true,
              message: "Invalid password!",
              snackType: "Error"
            })
            return;
          }

        }
      }
      else{
        data["autoGenerated"] = disable
      }
      PostData("/api/user/create", data).then((data) => {
        if (data.status === true) {
          setNewUser(data.newUser)
          setSnacBar({
            ...snacBar,
            snacStatus: data.status,
            message: data.message,
            snackType: "Success"
          })
          setForm({})
          setOpen(false)
        } else {
          setOpen(false)
          setSnacBar({
            ...snacBar,
            snacStatus: data.status,
            message: "Responce Failed",
            snackType: "Error"
          })
        }
      })
      // New User Creation********************************************
    }
  }

  return (
    <>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleClose} >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-2">
                    <div className="sm:flex sm:justify-center">

                      <div className="mt-10 sm:mt-0">
                        <div className="md:grid md:grid-cols-2 md:gap-6">
                          <div className="mt-5 md:mt-0 md:col-span-2">

                            <div className='font-medium'>
                              Create User
                            </div>
                            <div className='border-t border-gray-400 mt-2'></div>
                            <div className="px-4 bg-white sm:p-10">
                              <div className="grid grid-cols-6 gap-6">
                                <div className="col-span-6 sm:col-span-3">
                                  <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">
                                    First name
                                  </label>
                                  <input
                                    type="text"
                                    name="firstName"
                                    required
                                    value={form.firstName}
                                    onChange={handleChange}
                                    id="firstName"
                                    autoComplete="firstName"
                                    className={`block w-full px-3 py-1 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none`}
                                  />
                                </div>

                                <div className="col-span-6 sm:col-span-3">
                                  <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
                                    Last name
                                  </label>
                                  <input
                                    type="text"
                                    name="lastName"
                                    required
                                    value={form.lastName}
                                    onChange={handleChange}
                                    id="lastName"
                                    autoComplete="lastName"
                                    className={`block w-full px-3 py-1 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none`}
                                  />
                                </div>

                                <div className="col-span-6 sm:col-span-3">
                                  <label htmlFor="emailAddress" className="block text-sm font-medium text-gray-700">
                                    Email address
                                  </label>
                                  <input
                                    type="text"
                                    name="emailAddress"
                                    required
                                    value={form.emailAddress}
                                    onChange={handleChange}
                                    id="emailAddress"
                                    autoComplete="emailAddress"
                                    className={`block w-full px-3 py-1 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none`}
                                  />
                                </div>

                                {
                                  ID ? <div className="col-span-3">
                                  <label htmlFor="loginId" className="block text-sm font-medium text-gray-700">
                                    Login ID
                                  </label>
                                  <input
                                    type="text"
                                    name="loginId"
                                    required
                                    disabled
                                    value={form.loginId}
                                    onChange={handleChange}
                                    id="loginId"
                                    autoComplete="loginId"
                                    className={`block w-full px-3 py-1 text-base font-normal text-gray-700 bg-gray-100 bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none`}
                                  /> 
                                </div> : 

                                <div className="col-span-3">
                                  <label htmlFor="loginId" className="block text-sm font-medium text-gray-700">
                                    Login ID
                                  </label>
                                  <input
                                    type="text"
                                    name="loginId"
                                    required
                                    value={form.loginId}
                                    onChange={handleChange}
                                    id="loginId"
                                    autoComplete="loginId"
                                    className={`block w-full px-3 py-1 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none`}
                                  />
                                </div>
                                }


                                <div className="col-span-3">
                                  <label htmlFor="contact" className="block text-sm font-medium text-gray-700">
                                    Contact
                                  </label>
                                  <input
                                    type="text"
                                    name="contact"
                                    required
                                    value={form.contact}
                                    onChange={handleChange}
                                    id="contact"
                                    autoComplete="contact"
                                    className={`block w-full px-3 py-1 text-base font-normal text-gray-700 bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none`}
                                  />
                                </div>

                                <div className="col-span-3">
                                  <label htmlFor="residentialAddress" className="block text-sm font-medium text-gray-700">
                                    Residential Address
                                  </label>
                                  <input
                                    type="text"
                                    name="residentialAddress"
                                    required
                                    value={form.residentialAddress}
                                    onChange={handleChange}
                                    id="residentialAddress"
                                    autoComplete="residentialAddress"
                                    className={`block w-full px-3 py-1 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none`}
                                  />
                                </div>

                                <div className="col-span-6 sm:col-span-3">
                                  <label htmlFor="role" className="block text-sm font-medium text-gray-700">
                                    Role
                                  </label>
                                  <select
                                    id="role"
                                    name="role"
                                    required
                                    value={form.role}
                                    onChange={handleChange}
                                    autoComplete="role"
                                    className={`block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm`}
                                  >
                                    <option>Admin</option>
                                    <option>User</option>
                                  </select>
                                </div>


                                { 
                                  <div className="col-span-3">
                                  <label htmlFor="autoGenerate" className="block text-sm font-medium text-gray-700">
                                    Auto Generate
                                  </label>
                                  <input
                                    id="default-checkbox"
                                    disabled = {ID ? true : false}
                                    type="checkbox"
                                    onChange={handleDisable}
                                    className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"></input>
                                </div>}

                                { !ID && 
                                  disable === false &&
                                  <div className="col-span-3">
                                    <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                      Password
                                    </label>
                                    <input
                                      type="text"
                                      name="password"
                                      required
                                      value={form.password}
                                      onChange={handleChange}
                                      id="password"
                                      autoComplete="password"
                                      className={`block w-full px-3 py-1 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none`}
                                    />
                                  </div>
                                }

                                {!ID &&
                                  disable === false &&
                                  <div className="col-span-3">
                                    <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">
                                      Confirm Password
                                    </label>
                                    <input
                                      type="text"
                                      name="confirmPassword"
                                      required
                                      value={form.confirmPassword}
                                      onChange={handleChange}
                                      id="confirmPassword"
                                      autoComplete="confirmPassword"
                                      className={`block w-full px-3 py-1 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none`}
                                    />
                                  </div>
                                }

                              </div>
                            </div>
                            <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
                              <button
                                onClick={handleClose}
                                className="inline-flex justify-center mr-2 py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-400 hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                              >
                                Cancel
                              </button>

                              <button
                                onClick={handleSubmit}
                                type="submit"
                                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                              >
                                {ID ? "Edit" : "Save"}
                              </button>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>

          {snacBar?.snacStatus &&
            <Snackbar snackType={snacBar?.snackType} message={snacBar.message} style={true} />
          }
        </Dialog>
      </Transition.Root>
    </>
  )
}
